import { Box, Typography } from '@mui/material';
import { trophyIconSrc } from '../../assets/my-rewards';

/** Figma 11101:36254 + 11101:36256 — Total Winnings Worth banner */
export default function TotalWinningsBanner({ amount = 0, currencyLabel = 'Rupees' }) {
  const displayAmount = Number(amount) || 0;

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 745,
        mx: 'auto',
        mb: { xs: 2, md: 2.5 },
        borderRadius: '20px',
        border: '1px solid #ffeba7',
        background: 'linear-gradient(0deg, #6816d9 8.93%, #e810f7 110.27%)',
        px: { xs: 2, md: 3 },
        py: { xs: 2, md: 2.5 },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <Box
        component="img"
        src={trophyIconSrc}
        alt=""
        sx={{
          width: 64,
          height: 64,
          display: 'block',
          flexShrink: 0,
          filter: 'drop-shadow(0 4px 4px rgba(0, 0, 0, 0.15))',
        }}
      />

      <Box sx={{ textAlign: 'left' }}>
        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            fontSize: 16,
            lineHeight: 'normal',
            color: 'rgba(255, 255, 255, 0.8)',
            mb: 0.5,
          }}
        >
          Total Winnings Worth
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 0.75 }}>
          <Typography
            component="span"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 900,
              fontSize: { xs: 30, md: 36 },
              lineHeight: '26px',
              color: '#fff',
              textShadow: '0 4px 0 rgba(0, 0, 0, 0.36)',
            }}
          >
            {displayAmount}
          </Typography>
          <Typography
            component="span"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 500,
              fontSize: 16,
              lineHeight: 'normal',
              color: 'rgba(255, 255, 255, 0.8)',
              pb: 0.25,
            }}
          >
            {currencyLabel}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
